export function convertToCamelCase(str) {
  return str.split(' ').map((word, index) => {
      if (index === 0) {
        return word.toLowerCase(); // Lowercase the first word
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Capitalize subsequent words
    }).join(''); // Join all words together
}
